export default "__VITE_ASSET__h5zfy82S__"